import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { omit } from 'lodash';
import NumberField from './NumberField';
export default function CurrencyField(props) {
    const { currencySymbol = '£', numberProps } = props, rest = __rest(props, ["currencySymbol", "numberProps"]);
    const newProps = Object.assign(Object.assign(Object.assign({}, omit(props, 'numberProps')), { numberProps: Object.assign(Object.assign({}, omit(numberProps, 'prefix')), { prefix: currencySymbol }) }), rest);
    return (_jsx(NumberField, Object.assign({ clearable: true }, newProps)));
}
